'use client';

import { usePathname, useSearchParams } from 'next/navigation';

export function useAsPath() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams?.toString();
  const path = pathname ?? '';
  return search ? `${path}?${search}` : path;
}
